<template>
  <div>

    <h4 class="titulo-component">Consultar Inscrição</h4>
    <div class="container-form">

      <el-form @submit.native.prevent="onSubmit" :model="dados" ref="dados" label-position="top">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="Consultar Inscrição por" key="tipo_documento" :rules="[$requiredChange]" prop="tipo_documento">
                <el-select v-model="dados.tipo_documento">
                  <el-option key="cpf" label="CPF" value="cpf"></el-option>
                  <el-option key="registro" label="Registro de Nascimento" value="registro"></el-option>
                  <el-option key="cod_inscricao" label="Código de Inscrição" value="cod_inscricao"></el-option>
                </el-select>
              </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" v-if="dados.tipo_documento == 'cpf'">
              <el-form-item label="CPF" key="cpf" :rules="[$requiredBlur, $cpfBlur]" prop="documento">
                <el-input v-model="dados.documento" v-mask="'###.###.###-##'"></el-input>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="dados.tipo_documento == 'registro'">
              <el-form-item label="Registro de nascimento" key="registro" :rules="[$requiredBlur]" prop="documento">
                <el-input v-model="dados.documento" v-mask="'######.##.##.####.#.#####.###.#######-##'"></el-input>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" v-if="dados.tipo_documento == 'cod_inscricao'">
              <el-form-item label="Código de Inscrição" key="cod_inscricao" :rules="[$requiredBlur]" prop="documento">
                <el-input v-model="dados.documento" v-mask="'##########'"></el-input>
              </el-form-item>
          </el-col>
        </el-row>

        <el-alert v-if="erro" :title="erro" :closable="false" type="error" show-icon></el-alert>

        <div class="container-btns">
          <el-button native-type="submit" type="primary">Consultar</el-button>
        </div>
      
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      erro: '',
      dados: {
        tipo_documento: '',
        documento: ''
      },
    };
  },
  methods: {
    onSubmit() {

      this.$refs.dados.validate(async (valid) =>{ if(valid){

        let codInscricao = this.dados.documento

        if(this.dados.tipo_documento != 'cod_inscricao') {

          let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getCodInscricao/${this.dados.documento}`, this.$store.getters.getHeaderAuth);

          if(typeof response.data.erro !== 'undefined'){

            this.erro = response.data.erro;
            return;   
          }else{            
            codInscricao = response.data.codigo_inscricao;
          }         

        }

        window.location.href = `${this.$store.state.config.baseUrlApi}/comprovante-inscricao/${codInscricao}`;

      }else{
          window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
      }});

    }
  },
  watch: {
      'dados.tipo_documento': function(value){
        this.dados.documento = '';
      }
  },
};
</script>
<style>
  .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
      line-height: 0px !important;
  }
</style>